
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class POSOrderItemsGrid extends _Ext.GridBase<OrderItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.OrderItems'; }
        protected getDialogType() { return OrderItemsDialog; }
        protected getIdProperty() { return OrderItemsRow.idProperty; }
        protected getInsertPermission() { return OrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderItemsRow.localTextPrefix; }
        protected getService() { return POSOrderItemsService.baseUrl; }
        protected getInitialTitle() { return null; };

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
        withBom: boolean;
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container, options);


            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as TransactionRequest).PartyId = poscustomerid;
                //(this.view.params as TransactionRequest).InStock = ECommOrderItemsSelectGrid.InStock;
            }
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): OrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //private getEffectiveValue(item, field): any {
        //    var pending = this.pendingChanges[item.ProductID];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }

        //    return item[field];
        //}

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}